import React, {Component} from 'react';
import PropTypes from 'prop-types';
import translate from '../../services/translation';

export default class DownloadPdfButton extends Component {

    static propTypes = {
        downloadLink: PropTypes.string,
        downloadLinkTextOnly: PropTypes.string,
        downloadLinkAgency: PropTypes.string,
        fileName: PropTypes.string,
        type: PropTypes.string
    };

    initialState = {
        showShareForm: false,
        hasWithPicture: true,
        isAgency: false
    };

    constructor(props) {
        super(props);
        this.state = this.initialState;
    }

    toggleForm = () => {
        this.setState({showShareForm: !this.state.showShareForm})
    };



    downloadPdf = () => {
        let link = document.createElement('a');
        link.href = this.state.isAgency ? this.props.downloadLinkAgency.split('amp;').join('') : (this.state.hasWithPicture ? this.props.downloadLink.split('amp;').join('') : this.props.downloadLinkTextOnly.split('amp;').join(''));
        link.download = this.props.fileName !== '' ? this.props.fileName + '_' + Math.floor(Date.now() / 1000) + '.pdf' : 'itinerary_info.pdf';
        link.dispatchEvent(new MouseEvent('click'));
    };

    onChangeAgency = () => {
        this.setState(prevState => ({
            isAgency: !prevState.isAgency,
            hasWithPicture: true
        }));
    };

    onChangeWithPicture = () => {
        this.setState(prevState => ({
            hasWithPicture: !prevState.hasWithPicture
        }));
    };

    render() {
        const {showShareForm, hasWithPicture, isAgency} = this.state;
        const {type} = this.props;

        return (
            <div className='downloadPdfContainer'>
                <div className='downloadPdfButton'>
                    <button onClick={this.toggleForm}>
                        {type === 'excursion' ? translate('excursion_show_download') : translate('itinerary_show_download')}
                    </button>
                </div>
                {showShareForm &&
                <div className='downloadPdfFormFieldContainer'>
                    <div className='downloadFormOptions'>
                        <span>{translate('itinerary_show_download_agency')}</span>
                        <input type='checkbox' name='isAgency' checked={isAgency} onChange={this.onChangeAgency}/>

                        <span>{translate('itinerary_show_download_text_only')}</span>
                        <input type='checkbox' name='hasWithPicture' disabled={isAgency} checked={hasWithPicture} onChange={this.onChangeWithPicture}/>
                    </div>
                    <button onClick={() => this.downloadPdf()} >
                        {translate('itinerary_show_download_now')}
                    </button>
                </div>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Favourites/DownloadPdfButton.js